const TREE_NODE_DEFAULT_PROPS = {
    hash: "",
    childNodes: [],
    title: "",
    count: 0,
    attr: {},
    renameSaveText: "Save",
    renameAddText: "Add",
    $busy: false,
    $droppable: true,
    $visible: true,
    $checkable: false,
    searchSelected: false,
    displayChildren: true,
    checked: false,
    indeterminate: false,
    selected: false
};
const TREE_NODE_PROP_KEYS = Object.keys(TREE_NODE_DEFAULT_PROPS);
const getNodeExpanded = (id, expandedState)=>id !== undefined && typeof expandedState[String(id)] === "boolean" ? expandedState[String(id)] : true;
const treeNodePropsEqual = (prev, next)=>{
    const changedProps = TREE_NODE_PROP_KEYS.some((key)=>prev[key] !== next[key]);
    return !changedProps && prev.id === next.id && prev.$rename === next.$rename && prev.$create === next.$create && // Re-render when the expand map instance changes so nested children pick up sibling/descendant toggles.
    prev.expandedState === next.expandedState;
};
export { getNodeExpanded, treeNodePropsEqual };
